var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgView = function SvgView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M28.726 27.84C18.793 30.518 11.853 36.199 11.853 40c0 3.79 6.899 9.449 16.785 12.136A43.5 43.5 0 0 0 40 53.658c4.043 0 7.887-.577 11.362-1.522C61.248 49.45 68.148 43.79 68.148 40c0-3.801-6.94-9.482-16.873-12.16A43.5 43.5 0 0 0 40 26.342c-4.01 0-7.822.567-11.274 1.498M60.86 50.506c-5.372 2.926-12.736 5.152-20.86 5.152s-15.488-2.226-20.86-5.152c-2.683-1.461-4.93-3.13-6.535-4.844-1.547-1.651-2.752-3.62-2.752-5.662s1.205-4.01 2.752-5.662c1.605-1.714 3.852-3.383 6.535-4.844 5.372-2.926 12.736-5.152 20.86-5.152s15.488 2.226 20.86 5.152c2.683 1.461 4.93 3.13 6.535 4.844 1.547 1.651 2.752 3.62 2.752 5.662s-1.205 4.01-2.752 5.662c-1.605 1.714-3.852 3.383-6.535 4.844",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M40 43.97a3.97 3.97 0 1 0 0-7.94 3.97 3.97 0 0 0 0 7.94m0 2a5.97 5.97 0 1 0 0-11.94 5.97 5.97 0 0 0 0 11.94",
    clipRule: "evenodd"
  })));
};
export default SvgView;